import React from "react";

export default function ManageJobsInvitedEmptyState({ image, title, description }) {
  return (
    <div className="manage-jobs-invited-page__empty">
      <img src={image} alt="" className="manage-jobs-invited-page__empty-image" />
      <h2 className="manage-jobs-invited-page__empty-title">{title}</h2>
      <p className="manage-jobs-invited-page__empty-description">{description}</p>
    </div>
  );
}
